module.exports = __webpack_public_path__ + "img/shipo-map-tonnage.37a9fd7d.svg";